import React, { useEffect, useState } from 'react';
import { GetConfig } from './../../../../utilities/BL/Rollers';

export const FrontPageRollers = () => {
    const [theme, setTheme] = useState(null);

    useEffect(() => {
        loadTheme();
    }, []);

    const loadTheme = async () => {
        const res = await GetConfig(1); // 1 es el estadio principal
        if (res.success && res.data && res.data.themeId) {
            const themeRes = await fetch(`${process.env.REACT_APP_API_URL}Rollers/GetTheme/${res.data.themeId}`);
            const data = await themeRes.json();
            if (data.success) {
                setTheme(data.data);
            }
        }
    };

    const getMediaUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const apiBase = (process.env.REACT_APP_API_URL || '').replace('/api/', '/').replace('/api', '/');
        return `${apiBase}${path}`;
    };

    // Render background
    const renderBackground = () => {
        if (!theme) return <div className="rollers-screen-bg-color" style={{ backgroundColor: '#0f0f1a' }} />;
        if (theme.coverBackgroundType === 'video' && theme.coverBackgroundUrl) {
            return (
                <video 
                    src={getMediaUrl(theme.coverBackgroundUrl)} 
                    className="rollers-screen-bg-media" 
                    autoPlay loop muted playsInline 
                />
            );
        } else if (theme.coverBackgroundType === 'image' && theme.coverBackgroundUrl) {
            return (
                <img 
                    src={getMediaUrl(theme.coverBackgroundUrl)} 
                    className="rollers-screen-bg-media" 
                    alt="Background" 
                />
            );
        } else {
            return <div className="rollers-screen-bg-color" style={{ backgroundColor: theme.coverBackgroundColor || '#0f0f1a' }} />;
        }
    };

    return (
        <div className="rollers-screen-container">
            {renderBackground()}

            <div className="text-center position-relative"
                 style={{ 
                    zIndex: 10,
                    //maxWidth: '800px',
                    margin: '0 auto',
                    fontFamily: "'Press Start 2P', monospace"
                 }}>
                {theme?.sponsorLogoUrl ? (
                    <img 
                        src={getMediaUrl(theme.sponsorLogoUrl)} 
                        alt="Sponsor Logo" 
                        className="mb-4"
                        style={{ maxHeight: '140px', maxWidth: '400px', objectFit: 'contain' }}
                    />
                ) : (
                    <img 
                        src="/img/page/adsl-five.png" 
                        alt="ADSL Logo" 
                        className="mb-4"
                        style={{ maxHeight: '140px', objectFit: 'contain' }}
                    />
                )}
                <p className="text-uppercase fw-bold mb-5" style={{ color: '#fff', letterSpacing: '4px', fontSize: '4em' }}>Presenta</p>
                <h1 className="text-uppercase fw-black" style={{ fontSize: '8em', margin: '0 0 20px 0', color: '#ffffff', lineHeight: '3.8rem' }}>ARMA LA IMAGEN</h1>
            </div>

            <p className='FooterCredits' style={{ position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)', color: '#fff', zIndex: '1' }}>
                Hecho con ♥ por Interaktia | 2026
            </p>
        </div>
    );
};
